import React from "react";
import CommonLayout from "../../../Components/CommonLayout/CommonLayout";
import styles1 from "../Category/category.module.css";
import styles from "../Modifier/modifier.module.css";
import CategoryModal from "../../../Components/Modals/MenuCategoryModal/CategoryModal";
import { CiSearch } from "react-icons/ci";

const CourierService = ({meta}) => {
  return (
    <>
      <CommonLayout />
      <div className={styles1.container}>
        <div className={styles1.top_content}>
          <div>
            {/* <p className={styles1.p1}>
              Demo Rajesh <span className={styles1.span1}>(Bilaspur)</span>
            </p> */}
            <div className={styles1.border_search}>
              <input
                type="text"
                style={{
                  border: "none",
                  outline: "none",
                  backgroundColor: "transparent",
                }}
                // className={styles1.border_search}
                placeholder="Search"
              />
              <CiSearch size={"1.1rem"} />
            </div>
          </div>

          {/* <p className={styles1.p2_border} onClick={() => setChangeStore(true)}>
            Change Store
          </p> */}
        </div>
        <hr style={{ marginTop: "1.3rem" }} />
        <div className={styles.items__container}>
          {[...Array(10)].map((item) => (
            <div style={{ padding: "1rem" }}>
              <div
                style={{
                  display: "flex",
                  gap: "1rem",
                  flexWrap: "wrap",
                }}
              >
                {/* <div
                  style={{
                    width: "1rem",
                    height: "1rem",
                    borderRadius: "50%",
                    border: "2px solid green",
                  }}
                ></div> */}
                <p className={styles.p_header}>Add Veg Toppings</p>
              </div>
              <p className={styles.p__text}>
                {" "}
                {[...Array(10)].map((item) => "VEG TOPPINGS | ")}
              </p>
              <hr
                style={{
                  // borderBottom: "1px inset var(--bg-color1)",
                  marginTop: "1.6rem",
                }}
              />
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default CourierService;
